module.exports = __webpack_public_path__ + "images/emoji/abcd.a0215b6768042d42c1ba.png";